
export default [
  {
    path: '/admin/expense-items',
    name: 'expense-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/expense/expense-item')
  }
]
